<template>
  <d-list-group>
    <d-card-header class="border-bottom flex-header">
      <h6>Faktury i dokumenty</h6>
    </d-card-header>
    <d-list-group-item>
      <d-row
        :class="{
          'border-bottom': !isDraft,
          'py-2': true
        }">
        <d-col cols="12" lg="4" class="d-flex py-1">
          <strong class="my-auto">Faktura prowizyjna:</strong>
        </d-col>
        <d-col class="py-1">
          <template
            v-if="schedule.provision_invoice_id">
            <span class="mr-3">
              wygenerowano dnia <strong class="text-primary">{{ schedule.provision_invoice_date.slice(0, 10)}}</strong>
            </span>
            <d-button
              theme="success"
              :disabled="actionInProgress"
              @click.prevent="exportInvoiceToPdf('provision', schedule.provision_invoice_id)">
              <i class="material-icons">save_alt</i> Pobierz fakturę prowizyjną
            </d-button>
          </template>
          <ss-popover
            v-else-if="!schedule.can_generate_invoice || isAdmin !== 1">
            <d-button
              class="is-disabled isDisabled"
              theme="success"
              disabled
              @click.prevent="">
              Generuj fakturę prowizyjną
            </d-button>
            <template slot="tooltip">
              Aby wygenerować fakturę prowizyjną musisz mieć <span v-if="!schedule.company_id">wybraną spółkę oraz</span> opłaconą prowizję oraz mieć konto administratora.
            </template>
          </ss-popover>
          <template v-else>
            <d-button
              :class="{ isDisabled: !schedule.can_generate_invoice || isAdmin !== 1 }"
              theme="success"
              :disabled="!schedule.can_generate_invoice || actionInProgress"
              @click.prevent="generateInvoice('provision')">
              Generuj fakturę prowizyjną
            </d-button>
          </template>
        </d-col>
      </d-row>

      <template v-if="!isDraft">
        <d-row class="border-bottom py-2">
          <d-col cols="12" lg="4" class="d-flex">
            <strong class="my-auto">Faktura końcowa:</strong>
          </d-col>
          <d-col class="py-1">
            <template
              v-if="schedule.interest_invoice_id">
              <span class="mr-3">
                wygenerowano dnia <strong class="text-primary">{{ schedule.interest_invoice_date.slice(0, 10)}}</strong>
              </span>
              <d-button
                theme="success"
                :disabled="actionInProgress"
                @click.prevent="exportInvoiceToPdf('interest', schedule.interest_invoice_id)">
                <i class="material-icons">save_alt</i> Pobierz fakturę końcową
              </d-button>
            </template>
            <ss-popover
              v-else>
              <d-button
                :class="[{ 'disabled is-disabled': !scheduleFinished  || isAdmin !== 1}]"
                theme="success"
                :disabled="actionInProgress"
                @click.prevent="generateInvoice('interest')">
                Generuj fakturę końcową
              </d-button>
              <template slot="tooltip">
                Faktura końcowa będzie dostępna po zakończeniu umowy oraz aby wystawić fakturę musisz mieć konto administratora.
              </template>
            </ss-popover>
          </d-col>
        </d-row>

        <d-row class="border-bottom py-2">
          <d-col cols="12" lg="4" class="d-flex">
            <strong class="my-auto">Zaświadczenie o saldzie:</strong>
          </d-col>
          <d-col class="py-1">
            <div
              class="button-date-wrapper"
              style="display: inline-block; min-width: 190px;">
              <d-button
                style="width: 100%; margin-top: -1px;"
                class="ml-0"
                theme="success">
                <i class="material-icons">save_alt</i> Sprawdź saldo i pobierz zaświadczenie
              </d-button>
              <ss-date
                @picked="checkBalance(false)"
                type="text"
                name="certificate-of-balance-date"
                v-model="certificateOfBalanceDate"
                placeholder=""/>
            </div>
          </d-col>
        </d-row>

        <d-row
          v-if="schedule.discount_active !== 1 && schedule.discounts.length > 0"
          class="border-bottom py-2">
          <d-col cols="12" lg="4" class="d-flex">
            <strong class="my-auto">Zaświadczenie o saldzie przy symulacji bonifikaty:</strong>
          </d-col>
          <d-col cols="12" lg="4" class="py-1">
            <d-select
              type="text"
              name="discountForBalanceCheck"
              v-model="discountForBalanceCheck"
              placeholder="Wybierz bonifikatę">
              <option :value="null">--Wybierz bonifikatę</option>
              <option
                v-for="discount in schedule.discounts"
                :key="discount.id"
                :value="discount.id">
                {{ discount.discount_name }}
              </option>
            </d-select>
          </d-col>
          <d-col cols="12" lg="4" class="py-1">
            <div
              class="button-date-wrapper"
              style="display: inline-block; min-width: 190px;">
              <d-button
                style="width: 100%; margin-top: -1px;"
                class="ml-0"
                theme="success"
                :disabled="!discountForBalanceCheck">
                <i class="material-icons">save_alt</i> Sprawdź saldo i pobierz zaświadczenie
              </d-button>
              <ss-date
                v-if="discountForBalanceCheck"
                @picked="checkBalance(true)"
                type="text"
                name="certificate-of-balance-date"
                v-model="certificateOfBalanceDate"
                placeholder=""/>
            </div>
          </d-col>
        </d-row>

        <d-row class="border-bottom py-2">
          <d-col cols="12" lg="4" class="d-flex">
            <strong class="my-auto">Potwierdzenie uruchomienia pożyczki:</strong>
          </d-col>
          <d-col class="py-1">
            <template
              v-if="!schedule.document">
              <ss-file
                accept="application/pdf"
                v-model="document.file"
                class="my-auto">
              </ss-file>
              <d-button
                v-if="document.file"
                theme="success"
                class="ml-3"
                @click.prevent="saveDocument"
                :class="[{ isLoading: isDocumentSubmitting }]">
                <i class="material-icons" style="font-size: 14px;">save</i> Zapisz
              </d-button>
            </template>
            <template v-else>
              <span class="mr-3">
                wygenerowano dnia <strong class="text-primary">{{ schedule.document_upload_date.slice(0, 10)}}</strong>
              </span>
              <d-button
                :class="{ isLoading: isExportingDocument }"
                theme="success"
                @click.prevent="exportDocumentToPdf()">
                <i class="material-icons">save_alt</i> Pobierz dokument
              </d-button>
              <d-button
                class="ml-2"
                theme="danger"
                @click.prevent="removeScheduleDocument()">
                <i class="material-icons" style="font-size: 14px;">close</i> Usuń
              </d-button>
            </template>
          </d-col>
        </d-row>

        <d-row class="py-2">
          <d-col cols="12" lg="4" class="d-flex">
            <strong class="my-auto">Raport dla księgowego:</strong>
          </d-col>
          <d-col class="py-1">
            <ss-popover>
              <d-button
                :class="[{ isLoading: isExportingLoanReport }, { 'disabled is-disabled': !scheduleFinished}]"
                @click.prevent="downloadLoanReport"
                theme="success">
                <i class="material-icons">save_alt</i> Pobierz raport
              </d-button>
              <template slot="tooltip">
                Raport będzie dostępny po zakończeniu umowy.
              </template>
            </ss-popover>
          </d-col>
        </d-row>
      </template>
    </d-list-group-item>

    <d-card-header class="border-bottom flex-header">
      <h6>Dokumenty</h6>
      <d-button
        v-if="scheduleDocuments.length > 0 && !isDraft"
        @click.prevent="documentsEdit = !documentsEdit"
        theme="success">
        <i class="material-icons">edit</i> Edytuj
      </d-button>
      <d-button
        @click.prevent="addNewDocument"
        theme="primary">
        <i class="material-icons">add</i> Dodaj
      </d-button>
    </d-card-header>
    <d-list-group-item>
      <contract-docs-list
        v-if="documents"
        :documents-edit="documentsEdit"
        :is-draft="isDraft"
        :schedule-documents="scheduleDocuments"
        :schedule="schedule" />

    </d-list-group-item>

    <document-form-modal
      :is-modal-visible="isModalVisible"
      :selected-document="selectedDocument"/>
  </d-list-group>
</template>

<script>
import FileSaver from 'file-saver';
import ClientUtils from '@/utils/client';
import DocumentFormModal from '@/components/client/contract-partials/docs/DocumentFormModal.vue';
import SsDate from '@/components/common/SsDate';
import ContractDocsList from '@/components/client/contract-partials/docs/ContractDocsList.vue';

export default {
  name: 'ContractInvoicesAndDocs',
  components: {
    DocumentFormModal,
    SsDate,
    ContractDocsList,
  },
  props: {
    clientName: {
      default: '',
      type: String,
    },
    documents: {
      default: () => {},
      type: Array,
    },
    isAdmin: {
      required: 0,
      type: Number,
    },
    isDraft: {
      required: true,
      type: Boolean,
    },
    schedule: {
      required: true,
      type: Object,
    },
    scheduleFinished: {
      required: true,
      type: Boolean,
    },
  },
  computed: {
    scheduleDocuments() {
      if (this.documentsEdit) {
        return this.documents;
      }

      return this.documents.filter(doc => this.schedule.documents.includes(doc.id), []);
    },
  },
  data() {
    return {
      actionInProgress: false,
      certificateOfBalanceDate: null,
      document: {
        file: null,
        id: '',
      },
      documentsEdit: false,
      isDocumentEdit: false,
      isDocumentSubmitting: false,
      isExportingDocument: false,
      isExportingLoanReport: false,
      isModalVisible: false,
      isSendingReminder: false,
      selectedDocument: null,
      discountForBalanceCheck: null,
    };
  },
  mounted() {
    this.$bus.$on('document-form-modal-close', this.closeModal);
    this.$bus.$on('contract-reload-documents', this.handleDocumentReload);
    this.document.id = this.schedule.id;
    this.documentsEdit = this.isDraft;
  },
  beforeDestroy() {
    this.$bus.$off('document-form-modal-close', this.closeModal);
    this.$bus.$off('contract-reload-documents', this.handleDocumentReload);
  },
  methods: {
    closeModal(shouldReload = false) {
      this.isModalVisible = false;

      if (shouldReload) {
        this.$bus.$emit('reload-contract');
      }
    },
    handleDocumentReload(isNew = false) {
      if (isNew) {
        this.$bus.$emit('reload-contract');

        // Poczekaj na przeładowanie i dodaj nowy dokument do umowy
        setTimeout(() => {
          if (this.documents && this.documents.length > 0) {
            const lastDoc = this.documents[this.documents.length - 1];
            if (!this.schedule.documents.includes(lastDoc.id)) {
              this.schedule.documents.push(lastDoc.id);
            }
          }
        }, 500);
      }
    },
    removeScheduleDocument() {
      this.isSendingReminder = true;

      Vue.swal({
        title: 'Uwaga',
        html: 'Czy na pewno chcesz usunąć potwierdzenie uruchomienia pożyczki?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Tak',
        cancelButtonText: 'Nie',
        buttonsStyling: true,
      }).then((logout) => {
        if (logout.value) {
          axios.post('api/schedules/remove-document', {
            id: this.schedule.id,
          }).then((response) => {
            this.document.file = null;
            this.$bus.$emit('reload-contract');
          }).catch((error) => {
            Vue.swal({
              type: 'warning',
              title: 'Wystąpił błąd',
              text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
              showConfirmButton: true,
            });
          });
        } else {
          this.isSendingReminder = false;
        }
      });
    },
    exportInvoiceToPdf(type, id) {
      if (id <= 39) {
        this.exportOldInvoiceToPdf(type, id);
      } else {
        let url = this.schedule.interest_view_url;
        if (type === 'provision') {
          url = this.schedule.provision_view_url;
        }
        window.open(url, '_blank');
      }
    },
    exportOldInvoiceToPdf(type, id) {
      this.actionInProgress = true;

      axios.post(
        'api/invoices/download-invoice',
        { invoice_id: id },
        { responseType: 'blob' },
      ).then((response) => {
        const blob = new File(
          [response.data],
          `${this.clientName}_faktura_${type === 'interest' ? 'koncowa' : 'prowizyjna'}_${Vue.getCurrentDate()}.pdf`,
          { type: 'application/pdf' },
        );
        FileSaver.saveAs(blob);

        this.actionInProgress = false;
      }).catch((error) => {
        this.actionInProgress = false;
      });
    },
    generateInvoice(type) {
      this.actionInProgress = true;

      axios.post('api/invoices/generate-invoice', {
        schedule_id: this.schedule.id,
        type,
      }).then((response) => {
        this.schedule[`${type}_invoice_id`] = response.data.id;
        this.schedule[`${type}_invoice_date`] = Vue.getCurrentDate();
        this.schedule[`${type}_view_url`] = response.data.view_url;

        this.actionInProgress = false;
      }).catch((error) => {
        const errorMessage = error.response.data.error ? error.response.data.error : 'Wystąpił błąd podczas generowania faktury.';
        Vue.swal({
          type: 'error',
          text: errorMessage,
        });

        this.actionInProgress = false;
      });
    },
    checkBalance(with_discount) {
      const self = this;

      setTimeout(() => {
        axios.post(
          'api/schedules/get-balance',
          {
            id: self.schedule.id,
            date: self.certificateOfBalanceDate,
            with_discount: with_discount ? self.discountForBalanceCheck : 0,
          },
        ).then((response) => {
          let information = `Na dzień <strong>${self.certificateOfBalanceDate}</strong> suma zadłużenia <br />wynosiłaby <strong>${self.toNumber(response.data.to_finish_credit).replace('-', '')} zł</strong>.`;
          if (response.data.to_finish_credit < 0) {
            information = `Na dzień <strong>${self.certificateOfBalanceDate}</strong> suma nadpłaty <br />wynosiłaby <strong>${self.toNumber(response.data.to_finish_credit).replace('-', '')} zł</strong>.`;
          }
          Vue.swal({
            // title: 'Uwaga',
            html: information,
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Pobierz',
            cancelButtonText: 'Zamknij',
            buttonsStyling: true,
          }).then((submit) => {
            if (submit.value) {
              self.generateCertificateOfBalance(with_discount);
            }
          });
        }).catch((error) => {
          Vue.swal({
            title: 'Błąd systemu',
            text: 'Wystąpił błąd podczas obliczęń. Spróbuj ponownie za jakiś czas.',
            type: 'error',
          });
        });
      }, 500);
    },
    generateCertificateOfBalance(with_discount) {
      this.$nextTick(function () {
        axios.post(
          'api/schedules/generate-balance-pdf',
          {
            id: this.schedule.id,
            date: this.certificateOfBalanceDate,
            with_discount: with_discount ? this.discountForBalanceCheck : 0,
          },
          { responseType: 'blob' },
        ).then((response) => {
          const blob = new File(
            [response.data],
            `${this.clientName}_zaswiadczenie_o_saldzie_${this.certificateOfBalanceDate}.pdf`,
          );
          FileSaver.saveAs(blob);
        }).catch((error) => {
          Vue.swal({
            title: 'Nie udało się pobrać pliku',
            text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
            type: 'error',
          });
        });
      });
    },
    saveDocument() {
      const data = new FormData();
      Vue.appendFormdata(data, this.document);

      this.isDocumentSubmitting = true;
      axios.post('api/schedules/save-document', data).then((response) => {
        Vue.swal({
          type: 'success',
          title: 'Dokument został dodany.',
          showConfirmButton: true,
        }).then(() => {
          this.document = {
            id: '',
            name: '',
            client_id: '',
            type: '',
            file: null,
          };
          this.$bus.$emit('contract-reload-documents');

          this.$nextTick(() => {
            this.closeModal(true);
          });
        });
        this.isDocumentSubmitting = false;
      }).catch((error) => {
        this.isDocumentSubmitting = false;
        Vue.swal({
          type: 'warning',
          title: 'Wystąpił błąd',
          text: error.response.data.error ? error.response.data.error : 'Spróbuj ponownie później',
          showConfirmButton: true,
        });
      });
    },
    exportDocumentToPdf() {
      this.isExportingDocument = true;

      axios.post(
        `api/schedules/download-document?date=${Date.now()}`,
        { id: this.schedule.id },
        { responseType: 'blob' },
      ).then((response) => {
        const blob = new File(
          [response.data],
          `${this.clientName}_potwierdzenie_uruchomienia_pozyczki_${this.schedule.document_upload_date}.pdf`,
          { type: 'application/pdf' },
        );
        FileSaver.saveAs(blob);
        this.isExportingDocument = false;
      }).catch((error) => {
        this.isExportingDocument = false;
      });
    },
    downloadLoanReport() {
      this.isExportingLoanReport = true;

      axios.post(
        `api/reports/download-loan-report?date=${Date.now()}`,
        { schedule_id: this.schedule.id },
        { responseType: 'blob' },
      ).then((response) => {
        const blob = new File(
          [response.data],
          `${this.clientName}_raport_ksiegowosc_${this.certificateOfBalanceDate}.xlsx`,
        );
        FileSaver.saveAs(blob);
        this.isExportingLoanReport = false;
      }).catch((error) => {
        Vue.swal({
          title: 'Nie udało się pobrać pliku',
          text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
          type: 'error',
        });
        this.isExportingLoanReport = false;
      });
    },
    addNewDocument() {
      this.isDocumentEdit = false;
      this.selectedDocument = _.clone(ClientUtils._document);
      this.selectedDocument.client_id = this.schedule.client_id;
      this.isModalVisible = true;
    },
    toNumber(number) {
      return Vue.toNumber(number);
    },
  },
};
</script>
